import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { HTTPConnectionError, NotFoundError } from 'utils/errors';
import { TGetCompetitionParticipantsParams } from 'types/services';
import { TCompetitionParticipant } from 'types/state';
import { competitionsStoreMock } from 'services/mock/utils/competitionsModel';

export const GET_COMPETITION_PARTICIPANTS_MOCK_ID__CONNECTION_ERROR = -1;

export const getCompetitionParticipants = async (
  params: TGetCompetitionParticipantsParams
): Promise<TCompetitionParticipant[]> => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
  if (params.id === GET_COMPETITION_PARTICIPANTS_MOCK_ID__CONNECTION_ERROR) {
    throw new HTTPConnectionError();
  }
  const competition = competitionsStoreMock
    .getAllArticles()
    .find(({ id }) => id === params.id);
  if (!competition) {
    throw new NotFoundError();
  } else {
    return competition.participants;
  }
};
